<script lang="ts">
import { type Snippet } from 'svelte'

import { DRAWER_ANIMATION_DURATION, wasDrawerOpened } from '@/modules/drawers'
import { MESSENGER_FRAME_BORDER_RADIUS, px } from '@/modules/frames'
import { fly } from '@/utils/transitions'

import DrawerCloseButton from './DrawerCloseButton.svelte'
import DrawerFooter from './DrawerFooter.svelte'
import DrawerOverlay from './DrawerOverlay.svelte'

type Props = {
	isOpen?: boolean
	testId?: string
	children?: Snippet
	onClose: () => void
}

let { isOpen = true, testId, children, onClose }: Props = $props()

const borderRadius = px(MESSENGER_FRAME_BORDER_RADIUS)
const flyParams = { y: '100%', opacity: 1, duration: DRAWER_ANIMATION_DURATION }

const handleClose = () => onClose()
</script>

{#if isOpen}
	<DrawerOverlay onClick={handleClose}>
		<!-- svelte-ignore a11y_click_events_have_key_events -->
		<div
			role="button"
			tabindex="0"
			class="absolute bottom-0 left-0 bg-white flex flex-col w-full"
			style:border-top-left-radius={borderRadius}
			style:border-top-right-radius={borderRadius}
			style:max-height={`calc(100% - 16px)`}
			data-testid={testId}
			onclick={(e) => e.stopPropagation()}
			in:fly|global={{ ...flyParams, delay: $wasDrawerOpened ? DRAWER_ANIMATION_DURATION : 0 }}
			out:fly|global={flyParams}
		>
			<DrawerCloseButton onClick={handleClose} />
			{@render children?.()}
			<DrawerFooter />
		</div>
	</DrawerOverlay>
{/if}
